import { FC, CSSProperties } from "react";
import classNames from "classnames";
import { gotoOAuthPortal } from "../../services/auth";
import styles from "./index.module.css";
import { LS_KEY } from "../../constants";

interface IProps {
  theme: "light" | "dark";
  style?: CSSProperties;
}

const SigninButton: FC<IProps> = ({ theme, style }) => {
  return (
    <div
      className={classNames(styles["sign-in-button"], {
        [styles["sign-in-button-light"]]: theme === "light",
        [styles["sign-in-button-dark"]]: theme === "dark",
      })}
      style={style}
      onClick={() => {
        localStorage.setItem(LS_KEY.CLOSE_SIGNIN_TOOLTIP, "true");
        gotoOAuthPortal("login");
      }}
    >
      Sign In
    </div>
  );
};

export default SigninButton;
